import {
  GetUserRoleRequestSchema,
  GetUserRoleResponseSchema
} from '@/types/UserRole';
import {ENDPOINTS} from '@/utils/constants/apiEndPoints';
import api, {HTTPMethod} from '../helpers/api';

export const getUserRoleService = (signal) => {
  return api({
    method: HTTPMethod.GET,
    path: ENDPOINTS.LOAD_USER_ROLES,
    requestSchema: GetUserRoleRequestSchema,
    responseSchema: GetUserRoleResponseSchema,
    signal
  })();
};
